<template>
  <div>
    <v-dialog v-model="dialog" max-width="600px" scrollable persistent>
      <v-card>
        <v-toolbar dark color="primary" dense>
          <v-toolbar-title> Préstamos Detallado </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                class="mx-2 my-2"
                text
                fab
                small
                v-on="on"
                @click.stop="close"
              >
                X
              </v-btn>
            </template>
            <span>Cerrar</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row align="center">
              <v-col cols="4" align="center">
                <span class="font-weight-bold">Fecha Inicial</span>
              </v-col>
              <v-col cols="8" align="center">
                <v-menu
                  v-model="menFechIni"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="report.date_start"
                      label="Fecha Inicial"
                      prepend-icon="fa-calendar-alt"
                      readonly
                      v-on="on"
                      id="date_start"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="report.date_start"
                    @input="menFechIni = false"
                    :max="fechaHoy()"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4" align="center">
                <span class="font-weight-bold">Fecha Final</span>
              </v-col>
              <v-col cols="8" align="center">
                <v-menu
                  v-model="menFechFin"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="report.date_end"
                      label="Fecha Final"
                      prepend-icon="fa-calendar-alt"
                      readonly
                      v-on="on"
                      id="date_end"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="report.date_end"
                    @input="menFechFin = false"
                    :max="fechaHoy()"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary darken-1" outlined @click="close"
            >Cancelar</v-btn
          >
          <v-btn
            color="primary darken-1"
            :loading="loadingReport"
            :disabled="loadingReport"
            outlined
            @click="save"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { URL_APP } from "../../../util/constants";
import { createLinkFile } from "../../../util/functions";
export default {
  name: "LoanDetails",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      equipment: [],
      loadingReport: false,
      menFechIni: false,
      menFechFin: false,
      groups: [],
      report: { date_start: "", date_end: "" },
    };
  },

  computed: {},

  watch: {},
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.loading = true;
      this.$http
        .get(URL_APP + "/api/loan/selgrouptics")
        .then((response) => {
          this.groups = response.data;
          this.loading = false;
        })
        .catch((error) => {
          this.$root.$alert({
            text: error.response.data.message,
            color: "error",
            timeout: 2000,
          });
          this.loading = false;
        });
    },

    fechaHoy() {
      return new Date().toISOString().substr(0, 10);
    },

    close() {
      this.$emit("close");
    },

    async save() {
      // Evita múltiples ejecuciones (doble click)
      if (this.loadingReport) return;

      // validar datos antes de enviar
      if (!this.report.date_start || !this.report.date_end) {
        this.$root.$alert({
          text: "Debe seleccionar fecha inicial y fecha final",
          color: "red",
          timeout: 2000,
        });
        return;
      }

      try {
        this.loadingReport = true;
        this.$root.$loadApp(true);

        const response = await this.$http.get(
          `${URL_APP}/api/loan/loandetails`,
          {
            params: {
              date_start: this.report.date_start,
              date_end: this.report.date_end,
            },
            responseType: "blob",
          },
        );

        createLinkFile(response);
      } catch (error) {
        console.error(error);

        this.$root.$alert({
          text: "Error al Obtener el Reporte",
          color: "error",
          timeout: 2000,
        });
      } finally {
        // siempre se ejecuta
        this.loadingReport = false;
        this.$root.$loadApp(false);
        this.report.date_start = "";
        this.report.date_end = "";
      }
    },
  },
};
</script>
